export async function sendContactEmail(data) {
  // Send data to CRM (optional, don't block if it fails)
  try {
    // CORS issues with direct CRM access - use our own backend as a proxy instead
    // This avoids CORS issues since the backend can make server-to-server requests
    
    // Determine the API URL based on environment
    let apiUrl = '/api/crm-webhook';
    
    // If we're in development and have a specific API URL configured, use it
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_API_URL) {
      apiUrl = `${process.env.REACT_APP_API_URL}/api/crm-webhook`;
    }
    
    // API URL determined based on environment
    
    // Using fetch with a timeout to prevent long waits if the CRM is down
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
    
    const crmResponse = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      signal: controller.signal,
      body: JSON.stringify({
        firstName: data.name.split(' ')[0],
        lastName: data.name.split(' ').slice(1).join(' ') || data.name.split(' ')[0],
        email: data.email,
        phone: data.phone,
        message: data.message,
        formId: 'website-contact',
        source: 'website',
        sourceDetails: {
          page: window.location.pathname
        }
      })
    });
    
    clearTimeout(timeoutId);
    
    // Process CRM webhook response
    
    if (!crmResponse.ok) {
      console.warn('CRM webhook returned non-OK status:', crmResponse.status);
    }
  } catch (error) {
    // Log but continue - this shouldn't block the main email functionality
    console.warn('Optional CRM integration failed:', error.message);
  }

  try {
    // Determine the API URL based on environment
    // In production, API requests should be routed through a proxy or to the same domain
    // For local development, you might need to set REACT_APP_API_URL in your .env file
    let apiUrl = '/api/contact';
    
    // If we're in development and have a specific API URL configured, use it
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_API_URL) {
      apiUrl = `${process.env.REACT_APP_API_URL}/api/contact`;
    }
    
    // Send contact form data to API
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });

    // Process contact form API response

    if (!response.ok) {
      let errorMessage = 'Failed to send email';
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorData.error || errorMessage;
      } catch (jsonError) {
        // If response is not JSON, try to get text
        try {
          const textError = await response.text();
          if (textError) errorMessage = textError;
        } catch (textError) {
          // If we can't get text either, just use the status
          errorMessage = `Server error: ${response.status}`;
        }
      }
      throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending emails:', error);
    throw error;
  }
}
